<template>
  <div class="wrapper">
    <div class="total_top_contain" style="margin-top:10px">
      <div class="flex_row_start" style="padding-left:0px;margin:0px">
        <div class="font_14_color_000000" style="width:70px">工号:</div>
        <el-input v-model="jobNumber" placeholder="搜索工种" style="margin-right:29px;"> </el-input>
      </div>
      <div class="flex_row_end">
        <el-button type="primary" @click="queryMenthod">查询</el-button>
        <el-button @click="resetMenthod" style="margin-right:8px">重置</el-button>
        <el-dropdown>
          <span class="el-dropdown-link">
            展开<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>黄金糕</el-dropdown-item>
            <el-dropdown-item>狮子头</el-dropdown-item>
            <el-dropdown-item>螺蛳粉</el-dropdown-item>
            <el-dropdown-item disabled>双皮奶</el-dropdown-item>
            <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="middle_button_contain">
      <div class="flex_row_start" style="padding:0px;margin-bottom:20px">
        <el-button type="primary" icon="el-icon-plus" @click="addJobmenthod">添加</el-button>
        <el-button>通过EXCLE导入</el-button>
      </div>
    </div>
    <div class="total_botom_contain">
      <div class="total_bottom_right_contain">
        <div class="table_contain">
          <!-- 下部table -->
          <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="44"></el-table-column>
            <el-table-column
              v-for="(item, index) in tableColumn"
              :key="index"
              :prop="item.prop"
              :formatter="item.formatter"
              :width="item.width"
              :show-overflow-tooltip="true"
              :label="item.label"
            />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="display_center_center">
                  <el-button type="text" @click="handleEdite(scope.row)">编辑</el-button>
                  <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="text-right mt20"
          background
          layout="prev, pager, next, jumper, total"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :total="total"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 添加工种 -->
    <el-dialog title="添加工种" :visible.sync="isShowAddJobWindow" width="40%">
      <el-form style="padding-left:30px;padding-right:30px">
        <el-form-item label="工种名称:" label-width="80px">
          <el-input v-model="addJobName" autocomplete="off" placeholder="请输入工种名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowAddJobWindow = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddJob">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { PAGE_SIZE, PAGE_SIZES } from '@/lib/constants';
import Axios from '@/lib/axios';
import API from '@/lib/apiProcessList';
export default {
  data() {
    return {
      jobNumber: '', //工号
      isShowAddJobWindow: false, //是否显示弹窗
      addJobName: '', //添加的工种名称
      checkAll: false,
      isIndeterminate: true,
      tableColumn: [
        {
          prop: 'encodeDeviceId',
          label: '工种名称'
        },
        {
          prop: 'deviceName',
          label: '资格证书'
        },
        {
          prop: 'deviceName',
          label: '类别'
        },
        {
          prop: 'deviceName',
          label: '人数'
        }
      ],
      selectedApplicationIndex: 0,
      multipleSelection: [],
      pageSize: PAGE_SIZE,
      pageSizes: PAGE_SIZES,
      currentPage: 1,
      total: 0,
      tableData: []
    };
  },
  mounted() {},
  created() {
    this.handleQuery();
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },

    //查询
    queryMenthod() {},

    //重置
    resetMenthod() {},

    //添加工种
    addJobmenthod() {
      this.isShowAddJobWindow = true;
    },

    //确认添加工种
    confirmAddJob() {
      console.log('====工种==' + this.addJobName);
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.handleQuery(val);
    },

    // 查询列表
    handleQuery(val) {
      this.currentPage = val || 1;
      const that = this;
      Axios.requestWWWForm({
        url: '/unicom/encodeDevice/searchPage',
        data: {
          pageSize: that.pageSize,
          pageNo: that.currentPage
        }
      })
        .then(res => {
          if (res.data.code == '1000') {
            let currentdata = res.data;
            that.total = currentdata.totalCount;
            that.tableData = currentdata.result;
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    //编辑单行
    handleEdite(row) {
      console.log('编辑单行====' + JSON.stringify(row));
    },

    //删除单行
    handleDelete(row) {
      console.log('删除单行====' + JSON.stringify(row));
    },

    //单选框
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
}

.font_14_color_000000 {
  font-size: 14px;
  color: #000000 85%;
}

.title_font {
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-weight: 600;
}

.total_top_contain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding-left: 30px;
  padding-right: 30px;
  background: white;
  // margin-top: 24px;
}

.total_botom_contain {
  display: flex;
  justify-content: space-between;
}

.total_bottom_right_contain {
  width: 100%;
  background: white;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 18px;
}

.flex_row_start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.flex_row_end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.bottom_left_top_contain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  margin-left: 18px;
  margin-right: 18px;
}

.bottom_left_bottom_contain {
  padding-right: 18px;
  padding-left: 18px;
  margin-top: 13px;
  padding-bottom: 13px;
  overflow: hidden;
}

.flex_row_center_start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.flex_row_center_end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.icon_parent_label {
  background: #f5222d 100%;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  width: 35px;
  height: 16px;
  line-height: 16px;
  color: white;
}

.icon_son_label {
  background: #fa8c16 100%;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  width: 35px;
  height: 16px;
  line-height: 16px;
  color: white;
}

.isSHow_icon {
  display: none;
}

.margin_left_40 {
  margin-left: 0px;
}

.margin_right_5 {
  margin-right: 5px;
}

.icon_image {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.flex_row_start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.middle_button_contain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
  background: white;
}

.table_contain {
  border: 1px solid rgba(230, 230, 230, 1);
}

.handle_contain {
  display: flex;
  align-items: center;
  height: 48px;
  justify-content: flex-start;
  background: #fafafa 100%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
